import { makeStyles } from "@fluentui/react-components";

export const useStyle = makeStyles({
	container: {
		height: "100%",
		position: "relative",
		alignContent: "center",
	},
	resizeHint: {
		position: "absolute",
	}
});
